import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import logo from '../assets/logo.svg';

const links = [
  { to: '/', label: 'Home' },
  { to: '/services', label: 'Services' },
  { to: '/about', label: 'About' },
];

export default function Navbar() {
  const { pathname } = useLocation();
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => { setOpen(false); }, [pathname]);

  return (
    <nav style={{
      position: 'sticky', top: 0, zIndex: 100,
      background: scrolled ? 'rgba(255,255,255,0.97)' : '#fff',
      borderBottom: '1px solid #EBF4FD',
      boxShadow: scrolled ? '0 2px 16px rgba(12,68,124,0.08)' : 'none',
      transition: '0.2s ease',
    }}>
      <div className="container" style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', height: 68 }}>
        {/* Logo */}
        <Link to="/">
          <img src={logo} alt="Sagient Partners" style={{ height: 52 }} />
        </Link>

        {/* Desktop nav */}
        <div className="hide-mobile" style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
          {links.map(l => (
            <Link key={l.to} to={l.to} style={{
              padding: '8px 16px', borderRadius: 8, fontWeight: 500, fontSize: '0.95rem',
              color: pathname === l.to ? '#0C447C' : '#64748B',
              background: pathname === l.to ? '#EBF4FD' : 'transparent',
              transition: '0.15s ease',
            }}>{l.label}</Link>
          ))}
          <a href="/blog" style={{
            padding: '8px 16px', borderRadius: 8, fontWeight: 500, fontSize: '0.95rem',
            color: '#64748B', transition: '0.15s ease',
          }}>Blog</a>
          <Link to="/contact" style={{
            padding: '8px 16px', borderRadius: 8, fontWeight: 500, fontSize: '0.95rem',
            color: '#64748B', transition: '0.15s ease',
          }}>Contact</Link>
          <Link to="/contact" className="btn btn-primary" style={{ marginLeft: 12 }}>Get Started</Link>
        </div>

        {/* Mobile hamburger */}
        <button onClick={() => setOpen(!open)} style={{
          display: 'none', background: 'none', border: 'none', cursor: 'pointer',
          padding: 8,
        }} className="show-mobile" aria-label="Menu">
          <span style={{ display: 'block', width: 22, height: 2, background: '#0C447C', marginBottom: 5 }} />
          <span style={{ display: 'block', width: 22, height: 2, background: '#0C447C', marginBottom: 5 }} />
          <span style={{ display: 'block', width: 22, height: 2, background: '#0C447C' }} />
        </button>
      </div>

      {/* Mobile menu */}
      {open && (
        <div style={{ background: '#fff', padding: '12px 24px 20px', borderTop: '1px solid #EBF4FD' }}>
          {links.map(l => (
            <Link key={l.to} to={l.to} style={{
              display: 'block', padding: '10px 0', fontWeight: 500,
              color: pathname === l.to ? '#0C447C' : '#64748B',
              borderBottom: '1px solid #F1F5F9',
            }}>{l.label}</Link>
          ))}
          <a href="/blog" style={{
            display: 'block', padding: '10px 0', fontWeight: 500,
            color: '#64748B', borderBottom: '1px solid #F1F5F9',
          }}>Blog</a>
          <Link to="/contact" style={{
            display: 'block', padding: '10px 0', fontWeight: 500,
            color: '#64748B', borderBottom: '1px solid #F1F5F9',
          }}>Contact</Link>
          <Link to="/contact" className="btn btn-primary" style={{ marginTop: 16, width: '100%', justifyContent: 'center' }}>Get Started</Link>
        </div>
      )}
    </nav>
  );
}
